import React, { useState, useEffect, useRef } from 'react';
import Request from 'superagent';
import _ from 'lodash';
import keyGen from 'random-key';
import DisplayClock from './displayClock';
import { withCookies } from 'react-cookie';
import Configure from './configure';
import SelectEvent from './selectEvent';
import SelectScreen from './selectScreen';
import ResolveToken from './resolveToken';
import RmToolTip from './rmToolTip';
import io from 'socket.io-client';
import { Button, Row, Col, Grid, Modal, FormGroup, FormControl, ControlLabel, DropdownButton, MenuItem } from 'react-bootstrap';
import { UserInformation, CompanySite } from './style/configure.style';
import './css/mainScreen.css';

function MainScreen({ parent, cookies }) {

    const [userProfile, setUserProfile] = useState([{ customer_id: 0, site_id: 0, serverIP: '', companySiteName: '' }]);
    const [screenMode, setScreenMode] = useState('init');
    const [screenDisplay, setScreenDisplay] = useState([]);
    const [showLoginScreen, setShowLoginScreen] = useState(false);
    const [emailAddress, setEmailAddress] = useState('');
    const [password, setPassword] = useState('');
    const [passwordValidationState, setPasswordValidationState] = useState(null);
    const [newPasswordValidationState, setNewPasswordValidationState] = useState(null);
    const [changePassword, setChangePassword] = useState(false);
    const [newPassword1, setNewPassword1] = useState('');
    const [newPassword2, setNewPassword2] = useState('');
    const [signInButtonDisabled, setSignInButtonDisabled] = useState(true);
    const [databaseType, setDatabaseType] = useState('');
    const [userAccess, setUserAccess] = useState([]);
    const [currentModeForConfigComponent, setCurrentModeForConfigComponent] = useState('');
    const [newProgramVersionAvailable, setNewProgramVersionAvailable] = useState(false);
    const [show, setShow] = useState(false);
    const [guidCookieState, setGuidCookieState] = useState('');
    const [serverPHP, setServerPHP] = useState('');
    const [serverSocket, setServerSocket] = useState('');

    const socketRef = useRef({});

    // liveRef for socket event callbacks (avoid stale closures)
    const liveRef = useRef({});
    liveRef.current = { screenMode, userProfile, databaseType };

    useEffect(() => {
        const guidCookieVal = cookies.get('guid') || '';
        setGuidCookieState(guidCookieVal);

        let phpServer = '';
        if (window.location.hostname === 'localhost' || window.location.hostname.substr(0, 3) === '192') {
            //phpServer = 'devor.radio.management';
            phpServer = 'or.radio.management';
        } else {
            phpServer = window.location.host;
        }
        const thisURL = 'https://' + phpServer + '/php/getServerAddress.php';

        Request.get(thisURL).then(response => {
            const php = 'https://' + response.body[0].serverPHP;
            const sock = 'https://' + response.body[0].serverSocket;
            setServerPHP(php);
            setServerSocket(sock);

            const newProfile = [{ ...userProfile[0], serverIP: php, serverSocket: sock }];
            setUserProfile(newProfile);

            socketRef.current = io(sock, { forceNew: true });
            socketRef.current.on('connect', () => {
                socketRef.current.emit('REQUEST_VERSION', {});
            });
            socketRef.current.on('VERSION_UPDATE', data => {
                const isLocalDev = window.location.hostname === 'localhost' || window.location.hostname.startsWith('192.');
                if (!isLocalDev) {
                    setNewProgramVersionAvailable(window.myBuildVersion !== data.currentBuildVersion);
                }
            });

            getInitParms(php, guidCookieVal, newProfile);
        });

        const handleTouchMove = e => {
            // disable scroll in config mode (configureWidgets flag unused currently)
        };
        window.addEventListener('touchmove', handleTouchMove);
        return () => window.removeEventListener('touchmove', handleTouchMove);
    }, []);

    function getInitParms(php, guidCookieVal, currentProfile) {
        const jsonString = JSON.stringify([{ guidCookie: guidCookieVal }]);
        const url = php + '/php/ob_clock.php?argument1=getInitParms&argument2=' + jsonString;
        Request.get(url).then(response => {
            if (response.body[0].Result === 'OK') {
                let newUserAccess = [];
                _.map(response.body[0].data, dataRow => {
                    if (dataRow.table_name === 'rm_config') {
                        if (dataRow.key === 'databaseType') setDatabaseType(dataRow.value);
                    } else if (dataRow.table_name === 'v_user_access') {
                        newUserAccess.push(dataRow);
                    }
                });
                if (newUserAccess.length > 0) {
                    setupUserProfile(newUserAccess, 0, currentProfile, php, currentProfile[0].serverSocket);
                }
                displayClockByToken(currentProfile);
            } else {
                setScreenDisplay([
                    <h1 key="err">{response.body[0].Result}</h1>,
                    <div key="errdata">{response.body[0].data}</div>,
                ]);
            }
        });
    }

    function setupUserProfile(ua, row, profileBase, php, sock) {
        const base = profileBase || userProfile;
        const sphp = php || serverPHP;
        const ssock = sock || serverSocket;
        const newProfile = [{
            serverIP: sphp,
            serverSocket: ssock,
            customer_id: ua[row].customer_id,
            site_id: ua[row].site_id,
            companySiteName: ua[row].customer_name + '-' + ua[row].site_name,
            firstName: ua[row].first_name,
            lastName: ua[row].last_name,
            userAccessRow: ua[row].csc_id,
        }];
        setUserProfile(newProfile);
        setUserAccess(ua);

        const currentMode = liveRef.current.screenMode;
        if (currentMode === 'configure') {
            configureModules(newProfile);
        } else if (ua.length === 1) {
            configureModules(newProfile);
        }
    }

    function displayClockByToken(profileToUse) {
        const profile = profileToUse || userProfile;
        setScreenMode('resolveToken');

        let token = '';
        if (parent.match.url !== '/') {
            token = parent.match.params.token;
            token = token.toUpperCase();
        }

        const dbType = liveRef.current.databaseType;
        const databaseSpanStyle = { backgroundColor: dbType === 'dev' ? 'brown' : '#333333', borderRadius: '5px', paddingLeft: '5px', paddingRight: '5px' };
        const databaseTypeStyle = { display: dbType !== 'prd' ? 'table-cell' : 'none', color: 'white', position: 'absolute', bottom: 0, left: 0, right: 0, textAlign: 'center', verticalAlign: 'middle' };
        const databaseTypeText = dbType === 'dev' ? 'Development Database - Build No ' + window.myBuildVersion : '';

        setScreenDisplay([
            <div key="databaseString" style={{ display: 'table', width: '100%' }}>
                <div style={databaseTypeStyle}><span style={databaseSpanStyle}>{databaseTypeText}</span></div>
            </div>,
            <ResolveToken key="displayClockByToken" token={token} userProfile={profile} screenSelected={screenSelected} />,
        ]);
    }

    function screenSelected(selectedScreen) {
        const newProfile = [...liveRef.current.userProfile];
        newProfile[0] = {
            ...newProfile[0],
            customer_id: selectedScreen.customerID,
            site_id: selectedScreen.siteID,
            event_id: selectedScreen.eventID,
            companySiteName: selectedScreen.customerName + '-' + selectedScreen.siteName,
        };

        if (selectedScreen.deviceType === 'mobilePortrait') {
            selectedScreen.maxCols = 4; selectedScreen.maxRows = 10;
        } else if (selectedScreen.deviceType === 'mobileLandscape') {
            selectedScreen.maxCols = 8; selectedScreen.maxRows = 5;
        } else if (selectedScreen.deviceType === 'tablet') {
            selectedScreen.maxCols = 8; selectedScreen.maxRows = 13;
        } else {
            selectedScreen.maxCols = 12; selectedScreen.maxRows = 12;
        }

        setUserProfile(newProfile);
        displayClock(selectedScreen, newProfile);
    }

    function displayClock(ss, profileToUse) {
        const profile = profileToUse || userProfile;
        const screen = { ...ss, mode: 'token' };
        setScreenMode('clock');
        setScreenDisplay([
            <DisplayClock
                key="displayclock"
                selectedScreen={screen}
                userProfile={profile}
                exitDisplayClock={exitDisplayClock}
            />,
        ]);
    }

    function exitDisplayClock() {
        displayClockByToken();
    }

    function exitConfigMode() {
        displayClockByToken();
    }

    function configureModules(profileToUse) {
        const profile = profileToUse || userProfile;
        setScreenDisplay([
            <Configure key="configure"
                userProfile={profile}
                configInNewMode={configInNewMode}
                exitConfigMode={exitConfigMode} />,
        ]);
        setScreenMode('configure');
    }

    function configInNewMode(newMode) {
        setCurrentModeForConfigComponent(newMode);
    }

    function startLoginProcess() {
        if (userAccess.length > 0) {
            configureModules();
        } else {
            setShowLoginScreen(true);
        }
    }

    function openLogoutOption() {
        setSignInButtonDisabled(false);
        setShowLoginScreen(true);
    }

    function hideLoginScreen() {
        setShowLoginScreen(false);
    }

    function completeLogin() {
        if (userAccess.length > 0) {
            const newGuid = keyGen.generateBase30(30);
            cookies.set('guid', newGuid, { path: '/' });
            setUserAccess([]);
            setEmailAddress('');
            setPassword('');
            setUserProfile([{ customer_id: 0, site_id: 0, serverIP: serverPHP, companySiteName: '' }]);
            setShowLoginScreen(false);
            if (screenMode === 'configure') displayClockByToken();
            return;
        }

        const newGuid = keyGen.generateBase30(30);
        const params = { emailAddress, password, changePassword, newPassword: newPassword1, guidCookie: newGuid };
        const url = userProfile[0].serverIP + '/php/ob_clock.php?argument1=verifyCredentials&argument2=' + JSON.stringify([params]);
        Request.get(url).then(response => {
            if (response.body[0].Result === 'OK') {
                if (response.body[0].data[0].verified) {
                    setShowLoginScreen(false);
                    setupUserProfile(response.body[0].data, 0);
                    cookies.set('guid', newGuid, { path: '/' });
                    setGuidCookieState(newGuid);
                } else {
                    setPasswordValidationState('error');
                }
            }
        });
    }

    function handleLoginKeyDown(e) {
        if (e.key === 'Enter' && !signInButtonDisabled) {
            e.preventDefault();
            completeLogin();
        }
    }

    function handleChange(e) {
        if (e.target.name === 'changePassword') {
            setChangePassword(prev => !prev);
            return;
        }
        setPasswordValidationState(null);
        const { name, value } = e.target;
        const updates = { emailAddress, password, newPassword1, newPassword2, [name]: value };

        if (name === 'emailAddress') setEmailAddress(value);
        else if (name === 'password') setPassword(value);
        else if (name === 'newPassword1') setNewPassword1(value);
        else if (name === 'newPassword2') setNewPassword2(value);

        let errorCount = 0;
        if (changePassword) {
            const np1 = name === 'newPassword1' ? value : newPassword1;
            const np2 = name === 'newPassword2' ? value : newPassword2;
            if (np1.length < 8 || np2.length < 8 || np1 !== np2) {
                setNewPasswordValidationState('error');
                errorCount++;
            } else {
                setNewPasswordValidationState(null);
            }
        }
        const pw = name === 'password' ? value : password;
        const em = name === 'emailAddress' ? value : emailAddress;
        if (pw.length < 2 || em.length < 2) errorCount++;
        setSignInButtonDisabled(errorCount > 0);
    }

    function companySiteSelected(e) {
        if (screenMode === 'configure') setScreenDisplay([]);
        for (let x = 0; x < userAccess.length; x++) {
            if (userAccess[x].csc_id === e.target.value) {
                setupUserProfile(userAccess, x);
            }
        }
    }

    function refreshBrowser() {
        window.location.reload(true);
    }

    // ── Render ─────────────────────────────────────────────────────────────────

    const mainStyle = { height: '100vh', width: '100vw' };
    let gridStyle = { position: 'relative', zIndex: 100 };
    if (screenMode === 'clock') {
        let height = window.innerHeight;
        if (/iPad|iPhone|iPod/.test(navigator.userAgent)) height += 600;
        gridStyle = { zIndex: 100, paddingLeft: 0, paddingRight: 0, height: height + 'px' };
    }

    const cogGlyphStyle = {
        position: 'fixed', top: '5px', right: '6px', fontSize: '24px', width: '30px', height: '30px',
        display: screenMode === 'resolveToken' ? 'block' : 'none',
    };
    const bodyStyle = { height: changePassword ? '260px' : '170px' };
    const emailStyle = { width: '100%' };
    const colStyle = { lineHeight: '50px' };
    const errorMessageStyle = { color: 'red' };
    const newPasswordStyle = { display: changePassword ? 'block' : 'none' };
    const formVisibilityStyle = { display: userAccess.length > 0 ? 'none' : 'block' };
    const logonButtonText = userAccess.length > 0 ? 'Sign Out' : 'Sign In';
    const modalHeaderText = userAccess.length > 0 ? 'Sign Out' : 'Sign In';
    const currentUser = userAccess.length > 0 ? userAccess[0].first_name + ' ' + userAccess[0].last_name + ' is currently signed in' : '';

    let errrorMessage = '';
    if (passwordValidationState === 'error') {
        errrorMessage = 'Invalid Email Address or Password.  ';
        if (changePassword) errrorMessage += 'Password not changed.';
    }
    if (newPasswordValidationState === 'error') {
        if (newPassword1.length < 8 || newPassword2.length < 8) {
            errrorMessage += 'New password must be at least 8 characters long.';
        } else {
            errrorMessage += 'New Passwords Do Not Match.';
        }
    }

    let userString = 'Sign In';
    let companySiteList = [];
    let companySiteButton = [];
    if (userAccess.length > 0) {
        if (userAccess.length === 1) {
            userString = userAccess[0].first_name + ' ' + userAccess[0].last_name + ' @' + userAccess[0].customer_name + '-' + userAccess[0].site_name;
        } else {
            userString = userAccess[0].first_name + ' ' + userAccess[0].last_name + ' @';
            for (let x = 0; x < userAccess.length; x++) {
                companySiteList.push(
                    <option key={userAccess[x].csc_id} value={userAccess[x].csc_id}>
                        {userAccess[x].customer_name + '-' + userAccess[x].site_name}
                    </option>
                );
            }
            companySiteButton.push(
                <CompanySite key={2} onChange={companySiteSelected}
                    width={window.innerWidth - 150}
                    value={userProfile[0].userAccessRow} required>
                    {companySiteList}
                </CompanySite>
            );
        }
    }

    const userInfoDisplayStyle = { display: currentModeForConfigComponent !== 'clock' && screenMode !== 'clock' ? 'flex' : 'none' };
    const userInfoDetailsStyle = {
        position: 'absolute', top: '0',
        right: userString === 'Sign In' ? '10px' : '140px',
        lineHeight: '34px',
        ...userInfoDisplayStyle,
    };

    let userInfo = [];
    if (userString === 'Sign In') {
        userInfo.push(
            <UserInformation key="userDiv" userString={userString} width={window.innerWidth - 150}
                display={currentModeForConfigComponent !== 'clock' && screenMode !== 'clock' ? 'flex' : 'none'}>
                <span className="cog" style={{ position: 'absolute', right: 0, whiteSpace: 'nowrap' }} onClick={openLogoutOption}>
                    {userString}
                </span>
                {companySiteButton}
            </UserInformation>
        );
    } else {
        userInfo.push(
            <UserInformation key="userDiv" userString={userString} width={window.innerWidth - 150}
                display={screenMode === 'resolveToken' ? 'flex' : 'none'}>
                <RmToolTip itemText={userString} itemType="text" style={{ flex: '1 1 auto' }}
                    onClick={openLogoutOption} placement="bottom"
                    toolTipText={<span>Click to sign out</span>} />
                <div style={{ flex: '1 1 auto' }}>{companySiteButton}</div>
            </UserInformation>
        );
    }

    let modalBody = null;
    if (userAccess.length === 0) {
        modalBody = (
            <div>
                <form style={formVisibilityStyle}>
                    <FormGroup validationState={passwordValidationState}>
                        <Col componentClass={ControlLabel} xs={4} sm={3}>Email</Col>
                        <Col xs={8} sm={9}>
                            <FormControl type="text" autoFocus style={emailStyle}
                                value={emailAddress} name="emailAddress"
                                placeholder="Enter email" onChange={handleChange} onKeyDown={handleLoginKeyDown} />
                        </Col>
                        <Col componentClass={ControlLabel} xs={4} sm={3} style={colStyle}>
                            {changePassword ? 'Old Password' : 'Password'}
                        </Col>
                        <Col sm={9} xs={8} style={colStyle}>
                            <FormControl type="password" style={emailStyle} name="password"
                                value={password} placeholder="Enter password" onChange={handleChange} onKeyDown={handleLoginKeyDown} />
                        </Col>
                    </FormGroup>
                    <FormGroup validationState={newPasswordValidationState}>
                        <div style={newPasswordStyle}>
                            <Col componentClass={ControlLabel} xs={4} sm={3}>New Password</Col>
                            <Col xs={8} sm={9}>
                                <FormControl type="password" style={emailStyle} name="newPassword1"
                                    value={newPassword1} placeholder="Enter new password" onChange={handleChange} />
                            </Col>
                            <Col componentClass={ControlLabel} xs={4} sm={3} style={colStyle}>New Password</Col>
                            <Col xs={8} sm={9} style={colStyle}>
                                <FormControl type="password" style={emailStyle} name="newPassword2"
                                    value={newPassword2} placeholder="Enter new password again" onChange={handleChange} />
                            </Col>
                        </div>
                    </FormGroup>
                </form>
                <div style={formVisibilityStyle}>
                    <Col xs={4} sm={3} />
                    <Col xs={8} sm={9}>
                        <input name="changePassword" checked={changePassword}
                            onChange={handleChange} type="checkbox" value="" />
                        {' '}Change Password
                    </Col>
                </div>
                <div style={errorMessageStyle}>
                    <Col xs={4} sm={3} />
                    <Col xs={8} sm={9} style={colStyle}>{errrorMessage}</Col>
                </div>
            </div>
        );
    }

    return (
        <div style={mainStyle}>
            <Grid fluid style={gridStyle}>
                <Modal show={showLoginScreen} autoFocus onHide={hideLoginScreen}>
                    <Modal.Header closeButton>
                        <Modal.Title>{modalHeaderText}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body style={bodyStyle}>
                        {currentUser}
                        {modalBody}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button key="signInbutton" style={{ cursor: 'pointer' }}
                            disabled={signInButtonDisabled} name="signIn"
                            bsStyle="success" onClick={completeLogin}>
                            {logonButtonText}
                        </Button>
                        <Button key="cancel" bsStyle="danger" style={{ cursor: 'pointer' }} onClick={hideLoginScreen}>
                            Cancel
                        </Button>
                    </Modal.Footer>
                </Modal>

                {userInfo}

                <div style={{ display: screenMode === 'clock' || userString === 'Sign In' ? 'none' : 'block', position: 'relative' }}>
                    <RmToolTip itemText="settings" itemType="icon" placement="bottom"
                        onClick={startLoginProcess}
                        style={cogGlyphStyle}
                        toolTipText={<span>Click to configure events<br />and dashboards</span>} />
                </div>

                {screenDisplay}
            </Grid>

            <div style={{
                display: newProgramVersionAvailable && screenMode !== 'clock' ? 'block' : 'none',
                position: 'absolute', top: '10px', left: '10px',
                color: 'white', backgroundColor: 'gray', zIndex: 1000,
                padding: '15px', boxShadow: '4px 4px 11px 1px black', whiteSpace: 'nowrap',
            }}>
                <span style={{ paddingRight: '10px' }}>A new version of Orquestradio is available</span>
                <span style={{ color: 'yellow', cursor: 'pointer', fontWeight: '500px' }} onClick={refreshBrowser}>REFRESH</span>
            </div>
        </div>
    );
}

export default withCookies(MainScreen);
